var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLinkTermsOfUse = function SvgSocialLinkTermsOfUse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M45.2 1H16.8C8.074 1 1 8.074 1 16.8v28.4C1 53.926 8.074 61 16.8 61h3.098v9.136c0 1.284 1.076 2.326 2.362 2.326s2.362-1.042 2.362-2.326v-5.358c0-.9.754-1.632 1.658-1.632s1.612.73 1.612 1.632l-.03 12.478v.024c0 1.286 1.078 2.328 2.362 2.328s2.362-1.04 2.362-2.328V63.424a1.629 1.629 0 1 1 3.256 0l-.016 1.236v9.166c0 1.284 1.01 2.326 2.296 2.326s2.294-1.042 2.294-2.326V62.608c0-.808.63-1.478 1.408-1.608H45.2C53.926 61 61 53.926 61 45.2V16.8C61 8.074 53.926 1 45.2 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#social-link-terms-of-use_svg__a)",
    d: "M39.928 14.656H22.072c-3.032 0-5.5 2.362-5.5 5.268v20.648c0 2.904 2.468 5.268 5.5 5.268h7.06v3.032c0 .442.372.802.814.802s.814-.36.814-.802v-1.846c0-.31.26-.562.572-.562s.556.252.556.562l-.01 4.3v.008c0 .444.372.802.814.802a.81.81 0 0 0 .814-.802V46.56a.561.561 0 1 1 1.122 0l-.006.426v3.158c0 .442.348.802.79.802s.79-.358.79-.802v-3.866c0-.178.09-.336.226-.438h3.5c3.032 0 5.5-2.362 5.5-5.268V19.924c0-2.904-2.468-5.268-5.5-5.268m3.7 25.916c0 1.912-1.66 3.468-3.7 3.468H22.072c-2.04 0-3.7-1.556-3.7-3.468V19.924c0-1.912 1.66-3.468 3.7-3.468h17.856c2.04 0 3.7 1.556 3.7 3.468z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#social-link-terms-of-use_svg__b)",
    d: "M38.194 22.542H23.712a.899.899 0 1 0 0 1.8h14.482a.899.899 0 1 0 0-1.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#social-link-terms-of-use_svg__c)",
    d: "M38.194 28.887H23.712a.899.899 0 1 0 0 1.8h14.482a.899.899 0 1 0 0-1.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#social-link-terms-of-use_svg__d)",
    d: "M30.952 35.082H23.71a.899.899 0 1 0 0 1.8h7.242a.899.899 0 1 0 0-1.8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-link-terms-of-use_svg__a",
    x1: 31,
    x2: 31,
    y1: 16.908,
    y2: 52.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-link-terms-of-use_svg__b",
    x1: 30.952,
    x2: 30.952,
    y1: 16.908,
    y2: 52.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-link-terms-of-use_svg__c",
    x1: 30.952,
    x2: 30.952,
    y1: 16.909,
    y2: 52.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-link-terms-of-use_svg__d",
    x1: 27.332,
    x2: 27.332,
    y1: 16.908,
    y2: 52.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })))));
};
export default SvgSocialLinkTermsOfUse;